import { axiosInstance } from "#services/axiosInstance.js";
import { useMutation } from "react-query";

const usePut = (url, queryKey, params) => {
  const { isLoading, error, mutateAsync, isSuccess } = useMutation(
    queryKey,
    async (data) => {
      const result = await axiosInstance({
        method: "put",
        url: url,
        data: data,
        params: params,
      });
      return result.data;
    },
    {
      onError: (error) => {
        console.log(error);
      },
    }
  );

  return { isLoading, error, mutateAsync, isSuccess };
};

export default usePut;
